import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { pillTabsStylesHook } from '@mui-treasury/styles/tabs';
import TabPanel from './TabPanel';
import RegisteredEvents from './RegisteredEvents';
import UpComingEvents from './UpComingEvents';
import HostedEvents from './HostedEvents';
import NewEvent from '../../components/NewEvent';
import NewEventText from './NewEventText';
import { getUserBrowserStorage } from '../../constants';
import PublicIcon from '@material-ui/icons/Public';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import HostEventText from './HostEventText';
import PublicEventText from './PublicEventText';
import MyEventsText from './MyEventsText';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { eventTabsStyles } from '../../styles/eventTabsStyles';

const useStyles = makeStyles((theme) => eventTabsStyles(theme));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const EventTab = ({ image }) => {
  const classes = useStyles();
  const tabsStyles = pillTabsStylesHook.useTabs();
  const tabItemStyles = pillTabsStylesHook.useTabItem();
  const loggedIn = getUserBrowserStorage('isLogin');
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));

  const isNotHostOrAdmin =
    userDetails?.userType === 3 || !userDetails?.userType;
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div style={{ width: '100%' }}>
      <Tabs
        classes={tabsStyles}
        value={tabIndex}
        onChange={(e, index) => setTabIndex(index)}
        centered
      >
        {isNotHostOrAdmin ? null : (
          <Tab
            classes={tabItemStyles}
            label={
              <>
                <HostEventText />
              </>
            }
            {...a11yProps(0)}
          />
        )}
        {loggedIn === 'true' ? (
          <Tab
            classes={tabItemStyles}
            label={
              <>
                <MyEventsText
                  className={classes.eventTabsText}
                  style={{ display: 'none' }}
                />
                <EventSeatIcon className={classes.eventTabsIcons} />
              </>
            }
            {...a11yProps(isNotHostOrAdmin ? 0 : 1)}
          />
        ) : null}
        <Tab
          classes={tabItemStyles}
          label={
            <>
              <PublicEventText className={classes.eventTabsText} />
              <PublicIcon className={classes.eventTabsIcons} />
            </>
          }
          {...a11yProps(loggedIn === 'true' ? (isNotHostOrAdmin ? 1 : 2) : 0)}
        />
        {isNotHostOrAdmin ? null : (
          <Tab
            classes={tabItemStyles}
            style={{ minWidth: '20px !important' }}
            label={
              <>
                <NewEventText className={classes.eventTabsText} />
                <AddCircleOutlineIcon
                  // style={{ width: "50px !important" }}
                  className={classes.eventTabsIcons}
                />
              </>
            }
            {...a11yProps(3)}
          />
        )}
      </Tabs>

      {isNotHostOrAdmin ? null : (
        <TabPanel value={tabIndex} index={0}>
          <HostedEvents
            image={image}
            userId={userDetails?.userId}
            userType={userDetails?.userType}
            isNotHostOrAdmin={isNotHostOrAdmin}
          />
        </TabPanel>
      )}
      {loggedIn === 'true' ? (
        <TabPanel value={tabIndex} index={isNotHostOrAdmin ? 0 : 1}>
          <RegisteredEvents
            image={image}
            userId={userDetails?.userId}
            userType={userDetails?.userType}
            isNotHostOrAdmin={isNotHostOrAdmin}
          />
        </TabPanel>
      ) : null}
      <TabPanel
        value={tabIndex}
        index={loggedIn === 'true' ? (isNotHostOrAdmin ? 1 : 2) : 0}
      >
        <UpComingEvents
          image={image}
          userId={userDetails?.userId}
          userType={userDetails?.userType}
          isNotHostOrAdmin={isNotHostOrAdmin}
        />
      </TabPanel>
      {isNotHostOrAdmin ? null : (
        <TabPanel value={tabIndex} index={3}>
          <NewEvent />
        </TabPanel>
      )}
    </div>
  );
};

export default EventTab;
